import React from 'react'

import { Body2, Body3, Box, BorderStyle, Color, Space } from '@gousto-internal/citrus-react'

type CWCReviewsCardProps = {
  quote: string
  reviewer: string
}

// Forked from CustomerReviewsSection/components/ReviewsCard for this section only —
// corrects the box-shadow to Figma's Elevation/200 token (two drop-shadow layers),
// which the original component only applies the first layer of.
export function CWCReviewsCard({ quote, reviewer }: CWCReviewsCardProps) {
  return (
    <Box
      bg={Color.White}
      paddingH={5}
      paddingV={5}
      paddingBottom={0}
      borderWidth={0.5}
      borderStyle={BorderStyle.Solid}
      borderColor={Color.ColdGrey_100}
      boxShadow="0 4px 6px -2px rgba(33, 41, 48, 0.03), 0 12px 16px -4px rgba(33, 41, 48, 0.06)"
      style={{ borderRadius: '8px' }}
      width="325px"
      height="144px"
    >
      <Body2 size={4} color={Color.ColdGrey_800}>
        {quote}
      </Body2>
      <Space size={3} />
      <Body3 size={2} color={Color.ColdGrey_500}>
        {reviewer}
      </Body3>
    </Box>
  )
}
